import { useContext } from "react"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import { WebSocketContext } from "../../../../../../Providers/WebSocket/WebSocketContext"
import { Button, Typography } from "@mui/material"
import OneModal from "../../../../../../Components/OneModal/OneModal"
import OneSelect from "../../../../../../Components/OneSelect/OneSelect"
import { diasHorarioHibrido } from "../../../../../../Utils/optionsSelects"
import OneDatePicker from "../../../../../../Components/OneDatePicker/OneDatePicker"

const EdicaoHorario = ({ horarios, horarioToEdit, indexToEdit, setOpenHorario, openHorario, idCentral }) => {
    const { sendWs } = useContext(WebSocketContext)

    let data = Object.assign({}, horarioToEdit)

    const handleChange = (event) => {
        if (event.target.value != undefined) {
            if (event.target.type == 'checkbox') {
                data = { ...data, [event.target.name]: event.target.checked }
            } else {
                data = { ...data, [event.target.name]: event.target.value }
            }
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault()
        if (indexToEdit != null) {
            horarios[indexToEdit] = data
        } else {
            horarios.push(data)
        }
        sendWs("editarHorarioHibrido", { horario: horarios, id_central: idCentral })
    }

    return (
        <OneModal
            open={openHorario}
            setOpen={setOpenHorario}
            titleText={indexToEdit != null ? "Editar horário" : "Novo horário"}
            FooterButtons={FooterButtons}
            fullWidth={true}
            onClose={false}
            maxWidth="sm"
        >
            <form
                id="horario-form"
                onSubmit={handleSubmit}
                style={{ width: '100%' }}
            >
                {data &&
                <Grid xs={12} sx={{ alignItems: 'center' }}>
                    <Grid container xs py={0.5} sx={{ alignItems: 'center' }}>
                        <Grid md>
                            <Grid container xs={7} sx={{ alignItems: 'center' }}>
                                <Grid xs={12} md={2}>
                                    <Typography fontSize="13px" fontWeight='400' >Dia: </Typography>
                                </Grid>
                                <Grid xs={12} md={9}>
                                    <OneSelect
                                        defaultValue={data?.dia}
                                        required
                                        onChange={handleChange}
                                        name={"dia"}
                                        options={diasHorarioHibrido}
                                        valor="value"
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid md>
                            <Grid xs={7} container sx={{ alignItems: 'center' }}>
                                <Grid xs={12} md={3}>
                                    <Typography fontSize="13px" fontWeight='400' >Inicial: </Typography>
                                </Grid>
                                <Grid xs={12} md={8}>
                                    <OneDatePicker name="ini" type="time" inputformat="HH:mm" defaultValue={data?.ini} callback={handleChange} />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid md>
                            <Grid xs={7} container sx={{ alignItems: 'center' }}>
                                <Grid xs={12} md={3}>
                                    <Typography fontSize="13px" fontWeight='400' >Final: </Typography>
                                </Grid>
                                <Grid xs={12} md>
                                    <OneDatePicker name="fim" type="time" inputformat="HH:mm" defaultValue={data?.fim} callback={handleChange} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                }
            </form>
        </OneModal>
    )
}

export default EdicaoHorario

const FooterButtons = () => {
    return (
        <Grid container xs={12} sx={{ alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <span style={{ fontSize: '13px', margin: 0, padding: 0 }}>* Campos obrigatórios!</span>
            <Button color="one_primary" variant="contained" form="horario-form" type="submit">Salvar</Button>
        </Grid>
    )
}
